import { FC } from "react";

import "./TabbedSection.scss";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import Card from "components/v2/Card/Card";
import Tabs from "components/v2/Tabs/Tabs";
import Tab from "components/v2/Tabs/components/Tab";

type TabbedSectionProps = {
  isLoading: boolean;
  tabs: { key: string; title: string; content: React.ReactNode }[];
  activeKey: string;
  onTabSelect: (key: string) => void;
  title: string;
  className?: string;
};

const TabbedSection: FC<TabbedSectionProps> = function ({ isLoading, tabs, activeKey, onTabSelect, title, className }) {
  return (
    <div className={`tabbed-section ${className}`}>
      <Card borderRadius="md">
        <Card.Header title={title} />
        <div className="tabbed-section__container">
          {isLoading ? (
            <LoadingSkeleton />
          ) : (
            <Tabs activeKey={activeKey} onSelect={onTabSelect} type="underline">
              {tabs.map((tab) => (
                <Tab key={tab.key} eventKey={tab.key} title={tab.title}>
                  <div className="mt-3xl">{tab.content}</div>
                </Tab>
              ))}
            </Tabs>
          )}
        </div>
      </Card>
    </div>
  );
};

export default TabbedSection;
